import type {
  ContinuationEditData,
  ReceiptSummaryRow,
} from '@/components/molecules/ContinuationReceiptEditModal';

import type { SearchState, SearchTermType, SearchTextType, SortValue } from './types';

export function toNumber(value: unknown, fallback = 0): number {
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
}

export function toSearchTermType(value: unknown): SearchTermType {
  const v = toNumber(value, 1);
  if (v === 2 || v === 3) return v;
  return 1;
}

export function toSortValue(value: unknown): SortValue {
  const v = toNumber(value, 0);
  if (v === 1 || v === 2) return v;
  return 0;
}

export function toSearchTextType(value: unknown): SearchTextType {
  const v = toNumber(value, 0);
  if (v === 1 || v === 2 || v === 3) return v;
  return 0;
}

export function normalizeSearchTextFields(search: SearchState): SearchState {
  return {
    ...search,
    search_patient_id: search.search_text === 1 ? search.search_patient_id : '',
    search_patient_name: search.search_text === 2 ? search.search_patient_name : '',
    ini: search.search_text === 3 ? search.ini : '',
  };
}

/** UAT 2026-04-24: every 金額 on this screen is grouped in thousands. */
function yen(value: unknown): string {
  return `${toNumber(value, 0).toLocaleString()}円`;
}

/**
 * SCR-183 §6/19/7/20/21/8 — the fee lines of 領収明細編集 for R2.
 *
 * A2 bills 初検料 / 施術料 / 電気鍼; R2 has neither 初検料 nor 電気鍼 and bills the five
 * lines below instead. A fee the visit did not have shows 0円 like every other line
 * (HIT-13245), not a blank cell.
 */
export function r2SummaryRows(data: ContinuationEditData): ReceiptSummaryRow[] {
  return [
    { label: '施術料', value: yen(data.massage_price) },
    { label: '変形徒手矯正術', value: yen(data.orthomorphia_price) },
    { label: '温罨法', value: yen(data.hot_treatment_price) },
    { label: '温罨・電気光線器具', value: yen(data.electric_treatment_price) },
    { label: '明細書発行加算', value: yen(data.meisai_issue_fee) },
    { label: '施術報告書交付料', value: yen(data.treatment_report_price) },
  ];
}
